// Uses roles databaseId value
export const RolesEnum = {
  SuperAdmin: 0,
  SiteAdmin: 1,
  Driver: 2,
  TaskOffice: 3,
  Gate: 4,
  DriverSupervisor: 5,
  Transportation: 6,
  Auditor: 7,
  BasicTaskOffice: 8,
};

export type RolesEnum = (typeof RolesEnum)[keyof typeof RolesEnum];
